<template>
  <div class="svg-paw">
    <img src="/paw.svg" alt="Paw Graphic" />
  </div>
</template>

<script>
export default {
  name: "Paw",
};
</script>

<style scoped>
.svg-paw img {
  width: 2.5em;
  aspect-ratio: 1;
}
</style>
